import AvatarBadge from './AvatarBadge';

export default AvatarBadge;
